import { render, staticRenderFns } from "./course-study.vue?vue&type=template&id=3c0e763a"
import script from "./course-study.vue?vue&type=script&lang=js"
export * from "./course-study.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports